import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const ContentView = (props) => {
  const careviewItem = props.careviewItem;

  const questionTitle = careviewItem.questionData.questionTitle;
  const isRequired = careviewItem.questionData.isRequired;

  return (
    <Stack>
      <Box>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            <Translate
              expression='loomLead.LoomLeadDetail.CareviewSettings.Types.FreeFormText.Question'
            />
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '16px',
            }}
          >
            {questionTitle}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            <Translate
              expression='loomLead.LoomLeadDetail.CareviewSettings.Types.FreeFormText.RequiredTitle'
            />
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '16px',
            }}
          >
            <Translate
              expression={
                isRequired ?
                  'loomLead.LoomLeadDetail.CareviewSettings.Types.FreeFormText.Enabled' :
                  'loomLead.LoomLeadDetail.CareviewSettings.Types.FreeFormText.Disabled'
              }
            />
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};

ContentView.propTypes = {
  careviewItem: PropTypes.object.isRequired,
};
export default React.memo(ContentView);
